import _ from 'lodash/fp';
import makeApiRequest from '../../../api/makeApiRequest';

export const NAME = 'addressBookUsers';

const addressBookUsers = {
  name: NAME,
  state: {
    users: {},
  },
  reducers: {
    onLoaded: (state, users) => {
      return {
        ...state,
        users: { ...state.users, ...users },
      };
    },
  },
  effects: dispatch => ({
    async load(userIds, { oidcSession }) {
      const users = {};
      for (const userId of userIds) {
        const url = `/address-book/${userId}`;
        const [request] = makeApiRequest({ url }, oidcSession);
        const { error, data } = await request;
        if (error) {
          dispatch.errors.add({ realm: NAME, type: 'load', error });
        } else {
          dispatch.errors.remove({ realm: NAME, type: 'load' });
          users[userId] = data;
        }
      }
      dispatch.addressBookUsers.onLoaded(users);
    },
  }),
  messageListeners: {
    CONTACTS_MODIFIED({ payload: contacts, state }) {
      const {
        [NAME]: { users },
      } = state;

      for (const contact of contacts) {
        const modifiedUser = contact.attributes.patient || contact.attributes.physician;
        if (users[modifiedUser.id]) {
          this.load([modifiedUser.id]);
        }
      }
    },
  },
};

export default addressBookUsers;
